/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import PieChart from './chart-pie';
/** Multiple Language imports **/
import LanguageManager from '../../custom-classes/language-manager';
/** End of Multiple Language imports **/

/**
 * Manages the student average by Subject and grade
 */
class ChartStudentAverage extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            studentId : this.props.data.studentId,
            productId: this.props.data.productId,
            languages: this.props.data.languages,
            chartData: null,
            passedTotal: this.props.data.passedTotal,
            notPassedTotal: this.props.data.notPassedTotal
        };
    }

    /**
     * Sets the chart data
     */
    setData(){
        let labelPassed = LanguageManager.getTranslation("report-student-average.passed", this.state.languages);
        let labelNotPassed = LanguageManager.getTranslation("report-student-average.not-passed", this.state.languages);

        let dataChart = [{
            value: this.state.notPassedTotal,
            color:"#F7464A",
            highlight: "#ce0606",
            label: labelNotPassed
        }, {
            value:  this.state.passedTotal,
            color: "#42f456",
            highlight: "#a8ff7a",
            label: labelPassed
        }];

        this.setState({chartData:dataChart});
    }

    /**
     * Called on the first time
     */
    componentWillMount(){
        this.setData();
    }

    /**
     * Call when updated
     * @param props
     */
    componentWillReceiveProps(props){
        this.props = props;
        // Update data
        this.setState({passedTotal:this.props.data.passedTotal, notPassedTotal: this.props.data.notPassedTotal},()=>{
            this.setData();
        });
    }

    /**
     * Renders the pie chart
     * @returns {XML}
     */
    renderItem(){
        return <PieChart redraw data={this.state} refresh={this.state}  />;
    };

    /**
     * Render the chart only if there is any data. If not, do not render anything
     * @returns {XML}
     */
    render() {
        return(
            <div>
                {this.state.chartData ?
                    <div className="average-chart-row">
                        {this.renderItem(this.state.chartData)}
                    </div> : null
                }
            </div>
        )
    };
}

export default ChartStudentAverage;